import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { TypedTable } from "../../../../components/TypedTable";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";

interface ModalInformacionPedidoProps extends BaseModalProps {
	readonly idPedido: number;
}
export function ModalInformacionPedido(props: ModalInformacionPedidoProps) {
	const { data, isLoading, isError } = UseInfoPedido({ idPedido: props.idPedido });

	// if (isLoading) return <div>Cargando...</div>;
	// if (isError) return <div>Error al cargar la información del pedido</div>;
	// if (data == null) return <div>No se ha encontrado el pedido</div>;

	const slugPedido = data ? `| ${data.nombreCliente} | ${data.fechaPedido}` : "";

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title" >
					Pedido {props.idPedido} {slugPedido}
				</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="content-box big-box">
					{isLoading ? <div>Cargando...</div> : null}
					{isError ? <div>Error al cargar la información del pedido</div> : null}

					{data ? <div className="table-responsive">
						<TablaInfoPedido data={data.lineas} />
					</div> : null}
				</div>
				<div className="modal-footer">
					<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
				</div>
			</div>
		</BaseModal>
	);
}

interface TablaInfoPedidoProps {
	readonly data: LineaPedido[];
}
function TablaInfoPedido(props: TablaInfoPedidoProps) {
	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<LineaPedido>();
		const idAccesor = (data: LineaPedido) => {
			if (data.idArticulo == null) return data.descripcion ?? "-";
			if (data.descripcion == null) return data.idArticulo;
			return `${data.idArticulo}-${data.descripcion}`;
		};

		return [
			columnHelper.accessor("idLinea", { header: "Linea" }),
			columnHelper.accessor(idAccesor, { id: "Articulo", header: "Articulo" }),
			columnHelper.accessor("cantidad", { header: "Cantidad ped", cell: info => info.getValue() ?? "-" }),
			columnHelper.accessor("cantidadEmpaquetada", { header: "Cantidad emp", cell: info => info.getValue() ?? "-" }),
		];
	}, []);

	return (
		<TypedTable
			columns={columns}
			data={props.data}
			className="dataTable display"
		/>
	);
}
function UseInfoPedido(pedido: { idPedido: number; }) {
	return useQuery<InfoPedido>({
		queryKey: ["getInfoPedidoVenta", pedido.idPedido],
		queryFn: () => ComunicacionAjax.sendAjaxRequest<InfoPedido>("GET", "/getInfoPedidoVenta", { "idPedido": pedido.idPedido }),
	});
}
interface InfoPedido {
	nombreCliente: string;
	fechaPedido: string;
	lineas: LineaPedido[];
}
interface LineaPedido {
	idLinea: string,
	idArticulo: string | null,
	descripcion: string | null,
	cantidad: number | null,
	cantidadEmpaquetada: number | null,
}